import {
    FETCH_CREATE_DIARY_DATA_SUCCESS,
    FETCH_DIARY_OWNERS_LIST_SUCCESS,
    FETCH_DIARIES_BY_DATE_SUCCESS,
    SHOW_DIARY_FORM_LOADER,
    HIDE_DIARY_FORM_LOADER,
    SHOW_DIARY_OWNER_LOADER,
    HIDE_DIARY_OWNER_LOADER,
} from "../actions/actionConstants";

import {RESET_DIARY_FORM_DATA,
    FETCH_DIARY_TAGS_SUCCESS } from '../../../Diaries/actions/actionConstants'

const initialState = {
    tags: [],
    ownersList: [],
    formData: {},
    diariesByDate: [],
    isLoading: false,
    userId: null,
    canAddMoreDueDates: false,
    loadingOwners: false,
    timezoneData:[]
};

export default function (state = initialState, action) {

    switch (action.type) {
        case FETCH_CREATE_DIARY_DATA_SUCCESS:
            return Object.assign(
                {},
                state,
                {
                    ...action.payload
                }
            );
        case FETCH_DIARY_TAGS_SUCCESS:
            return Object.assign(
                {},
                state,
                {
                    ...action.payload
                }
            );
        case FETCH_DIARY_OWNERS_LIST_SUCCESS:
            return Object.assign(
                {},
                state,
                {
                    ...action.payload
                }
            );

        case FETCH_DIARIES_BY_DATE_SUCCESS:
            return Object.assign(
                {},
                state,
                {
                    ...action.payload
                }
            );

        case RESET_DIARY_FORM_DATA:
            return initialState

        case SHOW_DIARY_FORM_LOADER:
            return Object.assign({}, state, { isLoading: true });

        case HIDE_DIARY_FORM_LOADER:
            return Object.assign({}, state, { isLoading: false })

        case SHOW_DIARY_OWNER_LOADER:
            return Object.assign({}, state, { loadingOwners: true });

        case HIDE_DIARY_OWNER_LOADER:
            return Object.assign({}, state, { loadingOwners: false })

        default:
            return state;
    }
}